import ThankYouEmailSettingsForm from '../Components/ThankYouEmailSettingsForm'

export default function ThankYouEmailForm({ actionId }) {
  return (
    <div className= "margin-top double">
      <ThankYouEmailSettingsForm actionId={actionId} additionalMergeTags={{
        'This Email to Target': [
          {
            'featured': true,
            'slug': 'sent_email.subject_line',
            'label': 'Sent Email Subject Line',
            'description': 'The subject line of the email that was sent'
          },
          {
            'featured': true,
            'slug': 'sent_email.body',
            'label': 'Sent Email Body',
            'description': 'The body of the email that was sent'
          },
          {
            'featured': true,
            'slug': 'sent_email.recipient_names',
            'label': 'Sent Email Recipient Names',
            'description': 'The names of the recipients the email was sent to'
          }
        ]
      }} />
    </div>
  )
}
